/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailSignatureResponseDraftTemplateKey } from './emailSignatureResponseDraftTemplateKey';
import type { EmailSignatureResponseTemplateKey } from './emailSignatureResponseTemplateKey';
import type { SignatureTemplateConfig } from './signatureTemplateConfig';

/**
 * One signature row, with both the canonical (``saved_*``) and the
 * pending-draft (``draft_*``) state surfaced.
 *
 * The FE seeds the editor from ``draft_body_html`` when
 * ``has_unsaved_draft`` is true and falls back to ``body_html`` otherwise.
 * Real email sends always use the canonical ``body_html`` — drafts
 * never ship until published.
 */
export interface EmailSignatureResponse {
  id: string;
  name: string;
  body_html: string;
  body_plain: string;
  draft_name?: string;
  draft_body_html?: string;
  draft_body_plain?: string;
  revision?: number;
  is_draft?: boolean;
  has_unsaved_draft?: boolean;
  created_at: string;
  updated_at: string;
  signature_kind?: string;
  template_key?: EmailSignatureResponseTemplateKey;
  template_config?: SignatureTemplateConfig | null;
  draft_template_key?: EmailSignatureResponseDraftTemplateKey;
  draft_template_config?: SignatureTemplateConfig | null;
}
